import { render, staticRenderFns } from "./EDrawerMotivoAula.vue?vue&type=template&id=859adbee&scoped=true"
import script from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
export * from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
import style0 from "./EDrawerMotivoAula.vue?vue&type=style&index=0&id=859adbee&prod&setup=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859adbee",
  null
  
)

export default component.exports